<template>
    <div class="viewfull">
      <div v-if="tabIndex === 0" class="viewfull">
        <DadosCadastrais @cancelar="value => $emit('cancelar', value)" ref="dados"/>
      </div>
      <div v-if="tabIndex === 1">
        <Areas/>
      </div>
      <div v-if="tabIndex === 2">
        <Perfil ref="perfil"/>
      </div>
      <div v-if="tabIndex === 3">
        <Mandatos/>
      </div>
      <div v-if="tabIndex === 4">
        <AreaAcao/>
      </div>
      <div v-if="tabIndex === 5">
        <ANS/>
      </div>
      <div v-if="tabIndex === 6">
        <Certificacoes @cancelar="value => $emit('cancelar', value)" ref="certificacoes"/>
      </div>
      <div v-if="tabIndex === 7">
        <Anexos/>
      </div>
      <div v-if="tabIndex === 8">
        <Historico/>
      </div>
    </div>
</template>

<script>
import DadosCadastrais from '../DadosCadastrais/DadosCadastrais'
import Areas from '../Areas/Areas'
import Perfil from '../Perfil/Perfil'
import Mandatos from '../Mandatos/Mandatos'
import AreaAcao from '../AreaAcao/AreaAcao'
import ANS from '../ANS/ANS'
import Certificacoes from '../Certificacoes/Certificacoes'
import Anexos from '../Anexos/Anexos'
import Historico from '../Historico/Historico'

export default {
  components: {
    DadosCadastrais,
    Areas,
    Perfil,
    Mandatos,
    AreaAcao,
    ANS,
    Certificacoes,
    Anexos,
    Historico
  },
  props: {
    tabIndex: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="sass" scoped>
.viewfull
  display: grid
  flex: 1
</style>
